import { render, staticRenderFns } from "./trainee-public-detail.vue?vue&type=template&id=905b4a04&scoped=true"
import script from "./trainee-public-detail.vue?vue&type=script&lang=js"
export * from "./trainee-public-detail.vue?vue&type=script&lang=js"
import style0 from "./trainee-public-detail.vue?vue&type=style&index=0&id=905b4a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b4a04",
  null
  
)

export default component.exports